

<template>
<div>
<v-container>
<v-row>
<v-col cols="12" sm="12" lg="12">
   <EmailVerify></EmailVerify>
</v-col>
</v-row>   
</v-container>
   
</div>
</template>

<script>

import EmailVerify from '@/components/auto_register/gestion/EmailVerify.vue';



export default {
    data () {
    return {
              
    }
  },
  components: {
    
    EmailVerify
    
  },

  methods: {

}

}
    

</script>


